import { t } from "ttag";

import { ConsultationLanguagePreference } from "@/app/components/legacy-components";
import { Card } from "@/shared/ui";

export const LanguagePreference = () => {
  return (
    <Card.Root className="gap-6">
      <Card.Title>{t`1. Language preference`}</Card.Title>

      <ConsultationLanguagePreference />
    </Card.Root>
  );
};
